import { render, staticRenderFns } from "./index.vue?vue&type=template&id=deb6f06c"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=deb6f06c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports